import {
  useForm as useReactForm,
  UseFormProps as UseReactFormProps,
  ChangeHandler,
  FieldValues,
  UseFormReturn,
  UseFormRegister
} from "react-hook-form";

type UseFormProps<TFieldValues, TContext> = UseReactFormProps<
  TFieldValues,
  TContext
> & {
  trim?: boolean;
};

function useForm<
  TFieldValues extends FieldValues = FieldValues,
  TContext = any,
  TTransformedValues extends FieldValues = TFieldValues
>({
  trim = true,
  ...props
}: UseFormProps<TFieldValues, TContext> = {}): UseFormReturn<
  TFieldValues,
  TContext,
  TTransformedValues
> {
  const methods = useReactForm<TFieldValues>(props);

  const customRegister: UseFormRegister<TFieldValues> = (
    name,
    registerOptions
  ) => {
    const field = methods.register(name, registerOptions);
    const customOnBlur: ChangeHandler = async (event) => {
      const target = event.target;
      if (trim && typeof target.value === "string" && target.value) {
        target.value = target.value.trim();
      }
      field.onBlur(event);
    };
    return { ...field, onBlur: customOnBlur };
  };
  return { ...methods, register: customRegister };
}

export default useForm;
